// sessionStorage keys shared across the app. Centralised so the code that sets a
// flag and the code that clears it can't drift apart.

/**
 * Set to '1' when the user dismisses the "Personal Invited Challenges" card with
 * the X. Cleared on each successful login (see SignInAccount) so the card
 * reappears once per login session.
 */
export const CHALLENGE_PENDING_DISMISS_KEY = 'spc:challengePendingCardDismissed';

/**
 * Login-session cache of GetApplicationConfigurations (JSON rows).
 * Written after the post-login fetch; read on reload within the same tab session
 * so we do not refetch. Cleared on logout and at the start of each successful login.
 */
export const APPLICATION_CONFIG_SESSION_KEY = 'slotcheck:applicationConfigurations';

/**
 * Prefix for "the rotate-landscape user message was created for this user +
 * casino in this tab session" flags (value '1'). Full key:
 * `${USER_MESSAGE_ENSURED_KEY_PREFIX}${appUserPk}::${casinoId}`. Lets Explore skip
 * the CreateUserMessage POST on every visit. See lib/ensureUserMessage.
 */
export const USER_MESSAGE_ENSURED_KEY_PREFIX = 'spc:userMessageEnsured:';
